import { useSaveCommonCriteria } from '@src/entities/Criteria/ui/hooks/useSaveCommonCriteria';
import { Button } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Modal as ModalComponent } from '@uhg-abyss/web/ui/Modal';
import React from 'react';

/**
 * Modal: Deactivate
 *
 * This modal is used to deactivate the selected version of the entity.
 *
 * @param currentEntity
 * @param isOpen
 * @param refetch
 * @param setFocusedEntity
 * @param setIsOpen
 * @param setShowAll
 * @returns {Element}
 * @constructor
 */
export function Modal({
  currentEntity = {},
  isOpen = false,
  refetch = () => {},
  setFocusedEntity = () => {},
  setIsOpen = () => {},
  setShowAll = () => {},
}) {
  const handleDeactivation = useSaveCommonCriteria('deactivate');

  /**
   * handleClose
   *
   * Handles the closing of the modal.
   *
   * @returns {Promise<void>}
   */
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ErrorHandler location="src/features/CommonCriteria/Deactivate/components/Modal/Modal.jsx">
      <ModalComponent isOpen={isOpen} onClose={handleClose} title="Deactivate Common Criteria">
        <ModalComponent.Section>
          Are you sure you want to deactivate: <strong>{currentEntity?.name}</strong>?
        </ModalComponent.Section>
        <ModalComponent.Section>
          <Divider height={1} />
          <Layout.Group alignLayout="right">
            <Button onClick={handleClose} variant="outline">
              Cancel
            </Button>
            <Button
              onClick={async () => {
                await handleDeactivation(
                  {
                    ...currentEntity,
                    ...{
                      isActive: false,
                    },
                  },
                  refetch
                );
                setFocusedEntity(currentEntity?.name);
                setShowAll(true);
              }}
              variant="destructive"
            >
              Deactivate
            </Button>
          </Layout.Group>
        </ModalComponent.Section>
      </ModalComponent>
    </ErrorHandler>
  );
}
